<template>
  <app-logged id="PaginateAllIndex">
    <v-flex xs12>
      <app-widget
        search
        :paginate="paginate.lastPage > 1"
      >
        <div slot="widget-search">
          <v-text-field
            v-model="filter"
            ref="search"
            solo
            flat
            append-icon="search"
            :disabled="paginate.data.length === 0 && !filter"
            hide-details
            label="Procurar"
          />
        </div>
        <div slot="widget-content">
          <v-list
            v-if="paginate.data.length > 0"
            :two-line="$route.meta.twoLines"
          >
            <v-list-item
              v-for="(item, i) in paginate.data"
              :key="i"
              @click="goToEdit(item.id)"
            >
              <v-list-item-avatar>
                <v-avatar
                  color="secondary"
                  size="40"
                >
                  <v-icon dark>
                    {{ $route.meta.avatarIcon }}
                  </v-icon>
                </v-avatar>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-text="$route.meta.titleAttr(item)" />
                <v-list-item-subtitle
                  v-if="$route.meta.twoLines"
                  class="grey--text"
                  v-text="$route.meta.subtitleAttr(item)"
                />
              </v-list-item-content>
              <v-list-item-action v-if="!$route.meta.routeToDetail">
                <v-icon color="grey lighten-1">
                  arrow_forward_ios
                </v-icon>
              </v-list-item-action>
              <v-list-item-action v-else>
                <v-btn
                  icon
                  large
                  @click.stop="goToDetail(item.id)"
                >
                  <v-icon color="info">
                    info
                  </v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <v-list v-else>
            <v-list-item>
              <v-list-item-avatar>
                <v-icon class="black lighten-2 white--text">
                  thumb_down
                </v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-text="$route.meta.emptyList" />
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>
        <div slot="widget-paginate">
          <v-pagination
            :length="paginate.lastPage"
            v-model="page"
            :total-visible="totalPaginate"
          />
        </div>
      </app-widget>
    </v-flex>
    <app-button-float @click.native="goToAdd">
      <v-icon slot="button-float-icon">
        add
      </v-icon>
    </app-button-float>
  </app-logged>
</template>

<script>
import Store from '@/store'
import AppLogged from '@/components/layouts/AppLogged'
import AppWidget from '@/components/AppWidget'
import AppButtonFloat from '@/components/AppButtonFloat'
export default {
  name: 'PaginateAllIndex',
  components: {
    AppWidget,
    AppLogged,
    AppButtonFloat
  },
  data () {
    return {
      totalPaginate: 7,
      timeout: null
    }
  },
  computed: {
    page: {
      get () {
        return Store.getters[this.$route.meta.pageAttr]
      },
      set (val) {
        Store.commit(this.$route.meta.pageCommit, val)
      }
    },
    filter: {
      get () {
        return Store.getters[this.$route.meta.filterAttr]
      },
      set (val) {
        Store.commit(this.$route.meta.filterCommit, val)
      }
    },
    paginate: {
      get () {
        return Store.getters[this.$route.meta.paginateAttr]
      }
    }
  },
  watch: {
    page (val) {
      Store.dispatch(this.$route.meta.paginateMethod)
    },
    filter (val) {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.page = 1
        Store.dispatch(this.$route.meta.paginateMethod).finally(() => {
          this.focusInput()
        })
      }, 800)
    }
  },
  methods: {
    goToAdd () {
      this.$router.push({
        name: this.$route.meta.routeToCreate
      })
    },
    focusInput () {
      if (!this.$refs.search) return null
      this.$refs.search.focus()
    },
    goToEdit (id) {
      this.$router.push({
        name: this.$route.meta.routeToEdit,
        params: {
          id
        }
      })
    },
    goToDetail (id) {
      this.$router.push({
        name: this.$route.meta.routeToDetail,
        params: {
          id
        }
      })
    }
  }
}
</script>
